module.exports = __webpack_public_path__ + "img/aw.766d34b7.svg";